import React from 'react';
import Page from '../../components/Page';
import { EventDetails } from '../../sections/client-zs/EventDetails';

const Event = () => (
  <Page title="Szczegóły Wyjazdu">
    <EventDetails />
  </Page>
);

export default Event;
